import {createModule} from "@/router/type";
export default createModule([

], )
